import React, { useEffect, useRef, useState } from "react";

import { DROPDOWN_PAGE_SIZE, FILTER_DEBOUNCE_MS } from "../../../config/config";
import { ROUTE_CALENDAR } from "../../../config/lang";
import { call } from "../../../util/action";
import { translate } from "../../../util/util";

// The MIME type used to carry a dragged point between the panel and calendar cells.
export const POINT_DND_TYPE = "application/x-picsell-point";

// Left pane: a debounced, server-searched, draggable list of points. Dragging a row and
// dropping it onto a calendar day is how stops get added (native HTML5 drag-and-drop — no
// external dependency, to keep the fragile prod build untouched).
export default function PointSearchPanel({ lang }) {
  const [term, setTerm] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const debounceRef = useRef(null);

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      setLoading(true);
      const q = term ? `&search=${encodeURIComponent(term)}` : "";
      call({ method: "GET", url: `points/?page=1&page_size=${DROPDOWN_PAGE_SIZE}${q}` }, resp => {
        setResults(Array.isArray(resp) ? resp : resp?.results || []);
        setLoading(false);
      });
    }, FILTER_DEBOUNCE_MS);
    return () => debounceRef.current && clearTimeout(debounceRef.current);
  }, [term]);

  const onDragStart = (e, point) => {
    // Carry only the fields the calendar/save path needs.
    const payload = { id: point.id, name: point.name, address: point.address, locality: point.locality };
    e.dataTransfer.setData(POINT_DND_TYPE, JSON.stringify(payload));
    e.dataTransfer.effectAllowed = "copy";
  };

  return (
    <div className="rc-points-panel">
      <div className="rc-points-search">
        <span className="material-symbols-outlined">search</span>
        <input
          type="text"
          value={term}
          onChange={e => setTerm(e.target.value)}
          placeholder={translate(ROUTE_CALENDAR, "search_placeholder", lang)}
        />
      </div>
      <div className="rc-points-list">
        {loading && <div className="rc-points-hint">…</div>}
        {!loading && results.length === 0 && (
          <div className="rc-points-hint">{translate(ROUTE_CALENDAR, "no_points_found", lang)}</div>
        )}
        {results.map(point => (
          <div
            key={point.id}
            className="rc-point-chip"
            draggable
            onDragStart={e => onDragStart(e, point)}
            title={point.address || ""}
          >
            <span className="material-symbols-outlined rc-drag-handle">drag_indicator</span>
            <span className="rc-point-chip-body">
              <span className="rc-point-chip-name">{point.name}</span>
              {(point.locality?.name || point.address) && (
                <span className="rc-point-chip-sub">{point.locality?.name || point.address}</span>
              )}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
